import { Button } from 'components/buttons/button';
import { StandardInput } from 'components/forms/input';
import {
  createEmptyState,
  createStateWith,
} from 'components/text-editor/editor-utils';
import { TextEditor } from 'components/text-editor/text-editor';
import { convertToRaw, EditorState } from 'draft-js';
import gql from 'graphql-tag';
import {
  useGetUnstructuredDataQuery,
  GetUnstructuredDataQuery,
  UpdateUnstructuredDataMutation,
  useUpdateUnstructuredDataMutation,
} from 'lib/graphql-generated';
import { useInput } from 'lib/hooks/use-input';

export const VoucherSection = () => {
  const image = useInput<string>('');
  const text = useInput<EditorState>(createEmptyState());
  const handleInit = (data: GetUnstructuredDataQuery) => {
    if (data.unstructured_data_by_pk) {
      image.init(data.unstructured_data_by_pk.data.image || '');
      text.init(createStateWith(data.unstructured_data_by_pk.data.content));
    }
  };

  const { data, refetch, loading } = useGetUnstructuredDataQuery({
    variables: {
      title: 'vouchers',
    },
    onCompleted: (data) => {
      handleInit(data);
    },
  });

  const [save, { loading: saving }] = useUpdateUnstructuredDataMutation({
    variables: {
      title: 'vouchers',
      data: {
        image: image.value,
        content: convertToRaw(text.value.getCurrentContent()),
      },
    },
  });

  return (
    <article className='bg-white shadow rounded-md  py-6 px-4 sm:p-6'>
      <header className=''>
        <h2 className='header text-xl text-gray-900'>Voucher</h2>
        <p className='mt-1 text-sm text-gray-500'>
          Details for the voucher page in the Merch section.
        </p>
      </header>
      <form action='' className='mt-6 grid grid-cols-4 gap-6'>
        <StandardInput
          type='url'
          name='image'
          label='image'
          id='image'
          bind={{ ...image.bind }}
          className='col-span-2'
        />
        <div className='col-span-2'>
          <label>Text</label>
          <TextEditor
            state={text.value}
            setState={text.setValue}
            disableBooks
            disableEvents
            disableH2
            disableH3
            disableImages
            disableVideo
          />
        </div>
        <section className='col-span-full'>
          <Button
            buttonType='primary'
            disabled={
              (!text.isModified && !image.isModified) || saving || loading
            }
            loading={saving}
            onClick={() => {
              save().then((data) => {
                refetch().then((data) => {
                  handleInit(data.data);
                });
              });
            }}>
            Save
          </Button>
        </section>
      </form>
    </article>
  );
};
